<script setup></script>

<template>
	<svg class="icon_secondary" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style="width: 20px">
		<title>ionicons-v5-a</title>
		<polyline
			points="268 112 412 256 268 400"
			style="fill: none; stroke: var(--data__common_behind_color); stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 48px"
		/>
		<line
			x1="392"
			y1="256"
			x2="100"
			y2="256"
			style="fill: none; stroke: var(--data__common_behind_color); stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 48px"
		/>
	</svg>
</template>
<style>
/* .icon_secondary {
	stroke: var(--data__common_behind_color);
	fill: var(--data__common_behind_color);
	stop-color: var(--data__common_behind_color);
} */
</style>
